import columnSetLimit from '../../../rest/column-set-limit-graphql/index.tsx';

const columnSetLimitService = (
	boardId: string,
	columnId: number,
	limit: number | null,
	minimum: number | null,
) => columnSetLimit(boardId, columnId, limit, minimum);

export default columnSetLimitService;
